<script setup lang="ts">
import { ref } from 'vue'
import { vOnClickOutside } from '@vueuse/components'
import ButtonBadge from '@/shared/components/badge/BadgeButton.vue'
import ScaleTransition from '@/shared/components/transitions/ScaleTransition.vue'

interface Props {
  title: string
  icon: string
  badge?: boolean
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
defineEmits<Emits>()
defineOptions({ inheritAttrs: false })
const isActive = ref<boolean>(false)
</script>

<template>
  <div class="relative" v-on-click-outside="() => (isActive = false)">
    <ButtonBadge
      v-model="isActive"
      :title="title"
      :icon="icon"
      :badge="badge"
      @click="isActive = !isActive"
      v-bind="$attrs"
    />
    <ScaleTransition>
      <div
        v-if="isActive"
        class="z-40 absolute right-0 mt-1 origin-top-right border border-gray-800 bg-white focus:outline-none overflow-hidden text-nowrap shadow-md"
        v-bind="$attrs"
      >
        <slot></slot>
      </div>
    </ScaleTransition>
  </div>
</template>
